export const getAffordableQuotesConsumerAccuracy =
  "<p>It's important to be as accurate as possible so we* can provide the coverage that's right for you.</p>";

export const getAffordableQuotesGenericAgent =
  "<p>Thank you for using Simply Business to get a quote for your small business client.</p><p>Your agent details will be linked by Simply Business for every quote and policy you create.</p>";
